import { post } from '@/utils/request';

import type { IRealNameIdentification } from './interface';

export const fetchSubmitIdentificationInfo = (
  params: IRealNameIdentification.Request.IdentificationInfoReq,
) => {
  return post('user/realname_verify', params);
};
